import moment from "moment";
import { slotId } from "../../configs/constants";

export const formatVacationRequest = vacation => {
  const startDateSlot = vacation.start_date_slot || {};
  const endDateSlot = vacation.end_date_slot || {};
  const startSlotId = startDateSlot.id || slotId.MORNING;
  const endSlotId = endDateSlot.id || slotId.AFTERNOON;

  let startDateFormated = moment(vacation.start_date).set({ hour: 0, minute: 0 });
  let endDateFormated = moment(vacation.endDate).set({ hour: 23, minute: 59 });

  if (startSlotId === slotId.AFTERNOON) {
    startDateFormated = moment(vacation.start_date).set({ hour: 12, minute: 0 });
  }
  if (endSlotId === slotId.MORNING) {
    endDateFormated = moment(vacation.endDate).set({ hour: 11, minute: 59 });
  }
  return { ...vacation, start_date: startDateFormated, end_date: endDateFormated };
};



// WEBPACK FOOTER //
// src/components/planning/planning.utils.js